import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const CountWrapper = Styled.div`
	z-index:1;
`;

const NumberWrapper = Styled.div`
	line-height:26px;
	height:26px;
	width:22px;
	text-align:center;
	color:#535353;
	font-weight: 700;
`;

export const Count = ({number, remainingNames}) => {
	return (
		<CountWrapper title={remainingNames}>
			<NumberWrapper>+{number}</NumberWrapper>
		</CountWrapper>
	);
};

Count.propTypes = {
	number: PropTypes.number,
	remainingNames: PropTypes.string,
};
